import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AudioService {
  audioContext: AudioContext;
  constructor() { }

  async init() {
    this.audioContext = new window.AudioContext();

    await this.audioContext.resume();
  }

  beep(frequency: number, duration: number) {
    return new Promise<void>(async (resolve) => {
      if (!this.audioContext) {
        await this.init();
      }
      // Create
      const oscillator = this.audioContext.createOscillator();
      const gain = this.audioContext.createGain();
      oscillator.connect(gain);
      gain.connect(this.audioContext.destination);

      // Set Options
      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;
      gain.gain.value = 1;
      // Start
      oscillator.onended = () => {
        gain.disconnect(this.audioContext.destination);
        oscillator.disconnect(gain);
        resolve();
      };
      // 開始・終了タイミング指定 引数は ミリ秒ではなく秒
      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + (duration / 1000)); // Stop Timing
    });
  }

  beepRepeat(frequency: number, onDuration: number, offDuration: number, count: number) {
    return new Promise<void>(async (resolve) => {

      function sleep(ms: number) {
        return new Promise<void>(resol => setTimeout(resol, ms));
      }

      for (let i = 0 ; i < count ; i++) {
        await this.beep(frequency, onDuration);
        await sleep(offDuration);
      }
      resolve();
    });
  }

}
